import {faDisplay} from "@fortawesome/free-solid-svg-icons";

export default faDisplay;
